import React, { useEffect, useState } from 'react';
import { useAppSelector, useAppDispatch } from 'app/config/store';
import { Table, Row, Col, Tag, Spin, Space, Button, Form, Select, Breadcrumb, Card, Typography, Switch } from 'antd';
import { RouteComponentProps, useHistory, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getEcole } from '../ecole/ecole.reducer';
import { faSms, faSearch, faCreditCard } from '@fortawesome/free-solid-svg-icons';
import { getSession } from 'app/shared/reducers/authentication';
import {
  fetchSalaires,
  getSalaireGroupById,
  setSelectedSalaires,
  getValidSalairesForPayment,
  calculateTotalAmount,
} from './salaire.reducer';
import { JhiItemCount, JhiPagination, getSortState } from 'react-jhipster';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import { SalaireParams } from 'app/shared/model/salaire.model';
import SuiviSalaire from './SuiviSalaire';
import { useCheckIsAnneeInactive } from 'app/hooks/useCheckIsAnneeActive';

const { Title } = Typography;

const ListSalaires = ({ match, location }: RouteComponentProps<SalaireParams>) => {
  const salaireGroupId = match.params.salaireGroupId;
  const ecoleId = match.params.ecoleid;
  const anneeScolaireId = match.params.anneeScolaireId;
  const dispatch = useAppDispatch();
  const history = useHistory();
  const salaireList = useAppSelector(state => state.salaire.entities);
  const totalItems = useAppSelector(state => state.salaire.totalItems);
  const loading = useAppSelector(state => state.salaire.loading);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const salaireGroup = useAppSelector(state => state.salaire.salaireGroup);
  const selectedSalaires = useAppSelector(state => state.salaire.selectedSalaires);
  const totalAmount = useAppSelector(state => state.salaire.totalAmount);
  const inactiveAnnee = useCheckIsAnneeInactive(match.params.anneeScolaireId);

  const [paySalaire, setPaySalaire] = useState(false);

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(location, ITEMS_PER_PAGE, 'id'), location.search)
  );

  useEffect(() => {
    dispatch(getSession());
    dispatch(getEcole(ecoleId));
    dispatch(getSalaireGroupById(salaireGroupId));
    dispatch(getValidSalairesForPayment(salaireGroupId));
  }, []);
  useEffect(() => {
    dispatch(
      fetchSalaires({
        salaireGroupId,
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        montant: 0,
        numeroSalaire: '',
      })
    );
  }, [paginationState]);

  useEffect(() => {
    dispatch(calculateTotalAmount({ salaireGroupId, selectedSalaires }));
  }, [selectedSalaires]);

  function formatNumber(n) {
    return n < 10 && n !== 0 ? `0${n}` : `${n}`;
  }

  const handlePagination = (currentPage: number) => {
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });
  };

  const handlePayClick = () => {
    history.push(`/salaires/${ecoleId}/${anneeScolaireId}/${salaireGroupId}/paySalaires`);
  };

  const handleSwitchChange = (checked: boolean, salaireId: string) => {
    if (checked) {
      dispatch(setSelectedSalaires([...selectedSalaires, salaireId]));
    } else {
      dispatch(setSelectedSalaires(selectedSalaires.filter(id => id !== salaireId)));
    }
  };

  const handleSelectGroup = (type: 'ALL' | 'ENSEIGNANT' | 'PERSONNEL' | 'SECRETAIRE') => {
    let ids: string[] = [];

    if (type === 'ALL') {
      ids = dataSource.filter(item => item.statutSalaire !== 'PAYEE' && item.statutSalaire !== 'EN_ATTENTE').map(item => item.id);
    } else {
      ids = dataSource
        .filter(item => item.typePersonnel === type && item.statutSalaire !== 'PAYEE' && item.statutSalaire !== 'EN_ATTENTE')
        .map(item => item.id);
    }

    dispatch(setSelectedSalaires(ids));
  };

  const column = [
    {
      title: 'Matricule',
      dataIndex: 'matricule',
      key: 'matricule',
      align: 'center' as const,
    },
    {
      title: 'Nom',
      dataIndex: 'employeName',
      key: 'employeName',
      align: 'center' as const,
    },
    {
      title: 'Numéro de paiement',
      dataIndex: 'phone',
      key: 'phone',
      align: 'center' as const,
    },
    {
      title: 'Montant Brut',
      dataIndex: 'montant',
      key: 'montant',
      align: 'center' as const,
    },
    {
      title: 'Statut Salaire',
      dataIndex: 'statutSalaire',
      key: 'statutSalaire',
      align: 'center' as const,
      render: statutSalaire =>
        statutSalaire === 'EN_ATTENTE' ? (
          <Tag color="blue">En Attente</Tag>
        ) : statutSalaire === 'PAYEE' ? (
          <Tag color="green">Payé</Tag>
        ) : statutSalaire === 'NON_PAYEE' ? (
          <Tag color="red">Non Payé</Tag>
        ) : (
          <Tag color="#999">{statutSalaire}</Tag>
        ),
    },
    {
      title: 'Type',
      dataIndex: 'typePersonnel',
      key: 'typePersonnel',
      render: typePersonnel => <Tag color="blue">{typePersonnel}</Tag>,
    },
    {
      title: 'Inclure',
      dataIndex: 'id',
      key: 'include',
      align: 'center' as const,
      render: (id, record) => (
        <Switch
          size="small"
          checked={selectedSalaires.includes(id)}
          onChange={checked => handleSwitchChange(checked, id)}
          disabled={
            salaireGroup?.statut === 'PAYEE' ||
            paySalaire ||
            inactiveAnnee ||
            record.statutSalaire === 'PAYEE' ||
            record.statutSalaire === 'EN_ATTENTE'
          }
        />
      ),
    },
    {
      title: 'Details',
      dataIndex: 'id',
      key: 'id',
      align: 'center' as const,
      render: (id, record) => (
        <Space size="middle">
          <Button type="primary" style={{ height: 30, width: 45 }}>
            <Link to={`/salaires/${ecoleId}/${anneeScolaireId}/${record.id}/details`}>
              <FontAwesomeIcon icon="eye" />{' '}
            </Link>
          </Button>
        </Space>
      ),
    },
  ];

  const dataSource = Array.isArray(salaireList)
    ? salaireList
        .map((salaire, i) => ({
          key: salaire.id,
          id: salaire.id,
          matricule: salaire?.matricule || '',
          employeName: salaire.professeur || '',
          montant: salaire.montant,
          frais: salaire.frais,
          statutSalaire: salaire.statutSalaire,
          phone: salaire.numeroTelephonePaiement,
          typePersonnel: salaire.typePersonnel,
        }))
        .reverse()
    : [];

  const onSearch = vals => {
    const entity = {
      ...vals,
      salaireGroupId,
      page: paginationState.activePage - 1,
      size: paginationState.itemsPerPage,
      montant: 0,
      numeroSalaire: '',
    };
    dispatch(fetchSalaires(entity));
  };

  const handleChange = () => {
    const entity = {
      salaireGroupId,
      page: paginationState.activePage - 1,
      size: paginationState.itemsPerPage,
      montant: 0,
      numeroSalaire: '',
    };
    dispatch(fetchSalaires(entity));
  };

  return (
    <div>
      <Breadcrumb className="p-2">
        <Breadcrumb.Item>
          <Link to={`/home/${currentEcole && currentEcole.id}/${anneeScolaireId}`}>{currentEcole && currentEcole.nom}</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/salaires/${currentEcole && currentEcole.id}/${anneeScolaireId}`}>Salaire</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`${match.url}`}>Liste</Link>
        </Breadcrumb.Item>
      </Breadcrumb>
      <div>
        <SuiviSalaire salaireGroupId={salaireGroupId} />
      </div>
      <h3>Liste des Salaires</h3>
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <Title level={2} style={{ textAlign: 'center' }}>
          Total sélectionné: {formatNumber(selectedSalaires.length)}
        </Title>
        <div className="chart-title">
          Montant de l&apos;opération:&nbsp;
          <strong>{formatNumber(totalAmount)} FCFA</strong>
        </div>
      </div>
      <div style={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
        <Button
          type="primary"
          style={{ backgroundColor: inactiveAnnee ? '#ccc' : '#F28E19', color: 'white' }}
          disabled={(salaireGroup && salaireGroup.statut === 'PAYEE') || paySalaire || inactiveAnnee || selectedSalaires.length < 1}
          onClick={handlePayClick}
        >
          <FontAwesomeIcon icon={faCreditCard} />
          &nbsp; Payer les Salaires ({selectedSalaires.length})
        </Button>
      </div>
      <div style={{ marginBottom: 20, display: 'flex', gap: 10 }}>
        <Select
          placeholder="Choisir qui payer"
          style={{ width: 250 }}
          onChange={handleSelectGroup}
          disabled={salaireGroup?.statut === 'PAYEE' || paySalaire || inactiveAnnee}
        >
          <Select.Option value="ALL">Tout le monde</Select.Option>
          <Select.Option value="ENSEIGNANT">Professeurs</Select.Option>
          <Select.Option value="PERSONNEL">Personnel</Select.Option>
          <Select.Option value="SECRETAIRE">Secretaires</Select.Option>
        </Select>

        <Form name="basic" layout="inline" onFinish={onSearch}>
          <Row>
            <Col span={20} sm={20} md={20} xs={17} xxl={20} xl={20} lg={24}>
              <Form.Item name="statutSalaire">
                <Select placeholder="Status" allowClear onClear={handleChange}>
                  <Select.Option value="EN_ATTENTE">
                    <Tag color="blue">En attente</Tag>
                  </Select.Option>
                  <Select.Option value="PAYEE">
                    <Tag color="green">PAYE</Tag>
                  </Select.Option>
                  <Select.Option value="NON_PAYEE">
                    <Tag color="red">NON PAYE</Tag>
                  </Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={1} sm={1} md={1} xs={1} xxl={1} xl={1} lg={3}>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  <FontAwesomeIcon icon={faSearch} />
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>

      <div className="table-responsive">
        <Spin spinning={loading} tip="Chargement...">
          <Table columns={column} dataSource={dataSource.reverse()} bordered pagination={false} style={{ textAlign: 'center' }} />
        </Spin>
      </div>
      {totalItems ? (
        <div className={salaireList && salaireList.length > 0 ? 'table-responsive' : 'd-none'}>
          <Row className="justify-content-center">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </Row>
          <Row className="justify-content-center">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </Row>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default ListSalaires;
